import React, { useState, useEffect } from "react";
import { backendDomain } from "../../utils";

const Acmmi = () => {
  const [activeTab, setActiveTab] = useState("text");
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const [textContents, setTextContents] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [showUserModal, setShowUserModal] = useState(true);
  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [allowFreeNavigation, setAllowFreeNavigation] = useState(() => {
    // Check local storage for the setting, default to false
    const stored = localStorage.getItem("acmmi-allow-free-navigation");
    return stored ? JSON.parse(stored) : false;
  });
  const [showSingleFile, setShowSingleFile] = useState(() => {
    // Check local storage for the setting, default to false
    const stored = localStorage.getItem("acmmi-show-single-file");
    return stored ? JSON.parse(stored) : false;
  });
  const [isSaving, setIsSaving] = useState(false);
  const [showCongratulations, setShowCongratulations] = useState(false);

  // Handle window resize and initial mobile detection
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Set initial value
    checkIsMobile();

    // Add resize listener
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);
  // Shuffle function to randomize order
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Initialize form data with shuffled order
  const initializeFormData = () => {
    const baseData = {
      text: [
        {
          filename: "dia832_utt8.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia25_utt1.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia476_utt11.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia46_utt6.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia820_utt3.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia410_utt17.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia112_utt4.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia532_utt2.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia149_utt3.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia273_utt3.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia679_utt14.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia1018_utt12.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia804_utt0.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia431_utt18.txt",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
      ],
      audio: [
        {
          filename: "dia832_utt8.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia25_utt1.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia476_utt11.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia46_utt6.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia820_utt3.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia410_utt17.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia112_utt4.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia532_utt2.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia149_utt3.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia273_utt3.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia679_utt14.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia1018_utt12.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia804_utt0.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia431_utt18.wav",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
      ],
      visual: [
        {
          filename: "dia832_utt8.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia25_utt1.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia476_utt11.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia46_utt6.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia820_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia410_utt17.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia112_utt4.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia532_utt2.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia149_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia273_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia679_utt14.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia1018_utt12.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia804_utt0.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia431_utt18.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
      ],
      video: [
        {
          filename: "dia832_utt8.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia25_utt1.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia476_utt11.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia46_utt6.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia820_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia410_utt17.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia112_utt4.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia532_utt2.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia149_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia273_utt3.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia679_utt14.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia1018_utt12.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia804_utt0.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
        {
          filename: "dia431_utt18.mp4",
          content: "",
          emotion: "",
          valence: "",
          arousal: "",
          reasoning: "",
        },
      ],
    };

    // Shuffle each category
    return {
      text: shuffleArray(baseData.text),
      audio: shuffleArray(baseData.audio),
      visual: shuffleArray(baseData.visual),
      video: shuffleArray(baseData.video),
    };
  };

  const [formData, setFormData] = useState(initializeFormData());

  // Load text file contents and video transcripts
  useEffect(() => {
    const loadTextFiles = async () => {
      const textFiles = [
        "dia832_utt8.txt",
        "dia25_utt1.txt",
        "dia476_utt11.txt",
        "dia46_utt6.txt",
        "dia820_utt3.txt",
        "dia410_utt17.txt",
        "dia112_utt4.txt",
        "dia532_utt2.txt",
        "dia149_utt3.txt",
        "dia273_utt3.txt",
        "dia679_utt14.txt",
        "dia1018_utt12.txt",
        "dia804_utt0.txt",
        "dia431_utt18.txt",
      ];

      const contents = {};
      for (const filename of textFiles) {
        try {
          const response = await fetch(`/acmmi/text/${filename}`);
          const text = await response.text();
          contents[filename] = text.trim();
        } catch (error) {
          console.error(`Error loading ${filename}:`, error);
          contents[filename] = `Error loading ${filename}`;
        }
      }
      setTextContents(contents);

      // Update formData with loaded text contents
      setFormData((prev) => ({
        ...prev,
        text: prev.text.map((item) => ({
          ...item,
          content: contents[item.filename] || `Loading ${item.filename}...`,
        })),
        // Also update video tab with transcript contents
        video: prev.video.map((item) => {
          // Convert video filename to text filename
          const textFilename = item.filename.replace(".mp4", ".txt");
          return {
            ...item,
            content: contents[textFilename] || `Loading ${textFilename}...`,
          };
        }),
      }));
    };

    loadTextFiles();
  }, []);

  const basicEmotions = [
    "anger",
    "disgust",
    "fear",
    "joy",
    "neutral",
    "sadness",
    "surprise",
  ];

  const likertOptions = [1, 2, 3, 4, 5];

  const tabs = [
    { id: "text", label: "Text", icon: "T" },
    { id: "audio", label: "Audio", icon: "A" },
    { id: "visual", label: "Visual", icon: "V" },
    { id: "video", label: "Video", icon: "V" },
  ];

  const handleInputChange = (tabType, itemIndex, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [tabType]: prev[tabType].map((item, index) =>
        index === itemIndex ? { ...item, [field]: value } : item
      ),
    }));
  };

  // Check if a step is completed (all required fields filled)
  const isStepCompleted = (stepType) => {
    const stepData = formData[stepType];
    const itemsToCheck = showSingleFile ? stepData.slice(0, 1) : stepData;
    return itemsToCheck.every(
      (item) =>
        item.emotion && item.valence && item.arousal && item.reasoning.trim()
    );
  };

  // Get available steps (completed + next available)
  const getAvailableSteps = () => {
    const stepOrder = ["text", "audio", "visual", "video"];

    // If free navigation is enabled, all steps are available
    if (allowFreeNavigation) {
      return stepOrder;
    }

    const available = [];

    for (let i = 0; i < stepOrder.length; i++) {
      const step = stepOrder[i];
      if (i === 0 || completedSteps.has(stepOrder[i - 1])) {
        available.push(step);
      }
    }

    return available;
  };

  // Get clickable steps (only current step, not completed ones)
  const getClickableSteps = () => {
    // If free navigation is enabled, all available steps are clickable
    if (allowFreeNavigation) {
      return getAvailableSteps();
    }
    return [activeTab]; // Only the current step is clickable
  };

  // Get next step in sequence
  const getNextStep = (currentStep) => {
    const stepOrder = ["text", "audio", "visual", "video"];
    const currentIndex = stepOrder.indexOf(currentStep);
    if (currentIndex < stepOrder.length - 1) {
      return stepOrder[currentIndex + 1];
    }
    return null;
  };

  // Save modality data to backend
  const saveModalityData = async (modality, data) => {
    try {
      const response = await fetch(
        `${backendDomain()}/api/acmmi/save-modality`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userEmail: userInfo.email,
            modality: modality,
            data: data,
            userInfo: {
              firstName: userInfo.firstName,
              lastName: userInfo.lastName,
              email: userInfo.email,
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`${modality} modality data saved successfully:`, result);
      return result;
    } catch (error) {
      console.error(`Error saving ${modality} modality data:`, error);
      // Don't throw the error to prevent blocking the UI
      // You might want to show a toast notification here
      return null;
    }
  };

  // Handle manual save and proceed
  const handleSaveAndProceed = async (stepType) => {
    if (!isStepCompleted(stepType)) {
      alert("Please complete all fields before saving.");
      return;
    }

    setIsSaving(true);
    try {
      // Save the completed modality data to backend
      const modalityData = showSingleFile
        ? formData[stepType].slice(0, 1)
        : formData[stepType];
      const result = await saveModalityData(stepType, modalityData);

      if (result) {
        setCompletedSteps((prev) => new Set([...prev, stepType]));

        // Check if this was the video step (last step)
        if (stepType === "video") {
          // Show congratulations modal directly
          setShowCongratulations(true);
        } else {
          // Auto-advance to next step if available
          const stepOrder = ["text", "audio", "visual", "video"];
          const currentIndex = stepOrder.indexOf(stepType);
          if (currentIndex < stepOrder.length - 1) {
            const nextStep = stepOrder[currentIndex + 1];
            setActiveTab(nextStep);
          }

          // Scroll to top of page
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        alert("Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const validateUserInfo = () => {
    const errors = {};

    if (!userInfo.firstName.trim()) {
      errors.firstName = "First name is required";
    }

    if (!userInfo.lastName.trim()) {
      errors.lastName = "Last name is required";
    }

    if (!userInfo.email.trim()) {
      errors.email = "Email is required";
    } else if (!userInfo.email.endsWith("@mit.edu")) {
      errors.email = "Please use your MIT email address";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUserInfoSubmit = (e) => {
    e.preventDefault();
    if (validateUserInfo()) {
      setShowUserModal(false);
    }
  };

  const handleUserInfoChange = (field, value) => {
    setUserInfo((prev) => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (formErrors[field]) {
      setFormErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleFreeNavigationToggle = () => {
    const newValue = !allowFreeNavigation;
    setAllowFreeNavigation(newValue);
    localStorage.setItem(
      "acmmi-allow-free-navigation",
      JSON.stringify(newValue)
    );
  };

  const handleSingleFileToggle = () => {
    const newValue = !showSingleFile;
    setShowSingleFile(newValue);
    localStorage.setItem("acmmi-show-single-file", JSON.stringify(newValue));
  };

  const getColumnHeader = (tabType) => {
    switch (tabType) {
      case "text":
        return "Text";
      case "audio":
        return "Audio";
      case "visual":
        return "Visual";
      case "video":
        return "Video";
      default:
        return "Content";
    }
  };

  return (
    <>
      {/* CSS for spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* User Info Modal */}
      {showUserModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: isMobile ? "20px" : "40px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: isMobile ? "16px" : "20px",
              padding: isMobile ? "24px" : "40px",
              maxWidth: "500px",
              width: "100%",
              maxHeight: "90vh",
              overflow: "auto",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? "24px" : "28px",
                  fontWeight: "600",
                  color: "#1d1d1f",
                  letterSpacing: "-0.5px",
                }}
              >
                Welcome to ACMMI
              </h2>
              <p
                style={{
                  margin: "12px 0 0 0",
                  fontSize: isMobile ? "16px" : "18px",
                  color: "#86868b",
                  fontWeight: "400",
                }}
              >
                Please provide your information to continue
              </p>
            </div>

            <form onSubmit={handleUserInfoSubmit}>
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1d1d1f",
                    marginBottom: "8px",
                  }}
                >
                  First Name *
                </label>
                <input
                  type="text"
                  value={userInfo.firstName}
                  onChange={(e) =>
                    handleUserInfoChange("firstName", e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: `2px solid ${
                      formErrors.firstName ? "#ff3b30" : "#e5e5e7"
                    }`,
                    borderRadius: "12px",
                    fontSize: "16px",
                    backgroundColor: "white",
                    color: "#1d1d1f",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#007AFF";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(0, 122, 255, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = formErrors.firstName
                      ? "#ff3b30"
                      : "#e5e5e7";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="Enter your first name"
                />
                {formErrors.firstName && (
                  <p
                    style={{
                      color: "#ff3b30",
                      fontSize: "14px",
                      margin: "8px 0 0 0",
                    }}
                  >
                    {formErrors.firstName}
                  </p>
                )}
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1d1d1f",
                    marginBottom: "8px",
                  }}
                >
                  Last Name *
                </label>
                <input
                  type="text"
                  value={userInfo.lastName}
                  onChange={(e) =>
                    handleUserInfoChange("lastName", e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: `2px solid ${
                      formErrors.lastName ? "#ff3b30" : "#e5e5e7"
                    }`,
                    borderRadius: "12px",
                    fontSize: "16px",
                    backgroundColor: "white",
                    color: "#1d1d1f",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#007AFF";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(0, 122, 255, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = formErrors.lastName
                      ? "#ff3b30"
                      : "#e5e5e7";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="Enter your last name"
                />
                {formErrors.lastName && (
                  <p
                    style={{
                      color: "#ff3b30",
                      fontSize: "14px",
                      margin: "8px 0 0 0",
                    }}
                  >
                    {formErrors.lastName}
                  </p>
                )}
              </div>

              <div style={{ marginBottom: "32px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1d1d1f",
                    marginBottom: "8px",
                  }}
                >
                  MIT Email *
                </label>
                <input
                  type="email"
                  value={userInfo.email}
                  onChange={(e) =>
                    handleUserInfoChange("email", e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: `2px solid ${
                      formErrors.email ? "#ff3b30" : "#e5e5e7"
                    }`,
                    borderRadius: "12px",
                    fontSize: "16px",
                    backgroundColor: "white",
                    color: "#1d1d1f",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#007AFF";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(0, 122, 255, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = formErrors.email
                      ? "#ff3b30"
                      : "#e5e5e7";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="yourname@mit.edu"
                />
                {formErrors.email && (
                  <p
                    style={{
                      color: "#ff3b30",
                      fontSize: "14px",
                      margin: "8px 0 0 0",
                    }}
                  >
                    {formErrors.email}
                  </p>
                )}
              </div>

              <button
                type="submit"
                style={{
                  width: "100%",
                  backgroundColor: "#1d1d1f",
                  color: "white",
                  border: "none",
                  padding: "16px 24px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: "0 4px 16px rgba(29, 29, 31, 0.15)",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#000000";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#1d1d1f";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Continue to Session
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Congratulations Modal */}
      {showCongratulations && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: isMobile ? "20px" : "40px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: isMobile ? "16px" : "20px",
              padding: isMobile ? "32px 24px" : "48px 40px",
              maxWidth: "600px",
              width: "100%",
              maxHeight: "90vh",
              overflow: "auto",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              textAlign: "center",
            }}
          >
            {/* Success Icon */}
            <div
              style={{
                width: isMobile ? "80px" : "100px",
                height: isMobile ? "80px" : "100px",
                backgroundColor: "#34c759",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 32px",
                fontSize: isMobile ? "40px" : "50px",
                color: "white",
                fontWeight: "bold",
              }}
            >
              ✓
            </div>

            {/* Congratulations Text */}
            <h2
              style={{
                margin: "0 0 16px 0",
                fontSize: isMobile ? "28px" : "36px",
                fontWeight: "600",
                color: "#1d1d1f",
                letterSpacing: "-0.5px",
              }}
            >
              Congratulations! 🎉
            </h2>

            <p
              style={{
                margin: "0 0 24px 0",
                fontSize: isMobile ? "18px" : "20px",
                color: "#86868b",
                fontWeight: "400",
                lineHeight: "1.5",
              }}
            >
              You have successfully completed all four modalities of the ACMMI
              homework!
            </p>

            <p
              style={{
                margin: "24px 0 32px 0",
                fontSize: isMobile ? "16px" : "18px",
                color: "#1d1d1f",
                fontWeight: "500",
                lineHeight: "1.5",
              }}
            >
              You can now safely close this page.
            </p>
          </div>
        </div>
      )}

      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f5f5f7",
          padding: isMobile ? "10px" : "20px",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            backgroundColor: "white",
            borderRadius: isMobile ? "12px" : "20px",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "white",
              color: "#1d1d1f",
              padding: isMobile ? "32px 16px" : "48px 32px",
              textAlign: "center",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <h1
              style={{
                margin: 0,
                fontSize: isMobile ? "32px" : "42px",
                fontWeight: "600",
                letterSpacing: "-0.5px",
                color: "#1d1d1f",
              }}
            >
              ACMMI - Homework
              {userInfo.firstName && userInfo.lastName && (
                <span
                  style={{
                    fontSize: isMobile ? "20px" : "24px",
                    fontWeight: "400",
                    color: "#86868b",
                    display: "block",
                    marginTop: "8px",
                  }}
                >
                  Welcome, {userInfo.firstName} {userInfo.lastName}
                </span>
              )}
            </h1>
            <p
              style={{
                margin: "16px 0 0 0",
                fontSize: isMobile ? "17px" : "20px",
                color: "#86868b",
                fontWeight: "400",
                letterSpacing: "0.1px",
              }}
            >
              Multi-Modal Emotion Analysis & Rating
            </p>
            {/* Progress Indicator */}
            <div
              style={{
                margin: "20px auto 0",
                maxWidth: "400px",
                backgroundColor: "#f0f0f0",
                borderRadius: "10px",
                height: "8px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${(completedSteps.size / 4) * 100}%`,
                  height: "100%",
                  backgroundColor: "#34c759",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
            <p
              style={{
                margin: "8px 0 0 0",
                fontSize: isMobile ? "14px" : "16px",
                color: "#86868b",
                fontWeight: "500",
              }}
            >
              Step {completedSteps.size + 1} of 4 -{" "}
              {tabs.find((t) => t.id === activeTab)?.label}
            </p>
          </div>

          {/* Step Navigation */}
          <div
            style={{
              display: "flex",
              backgroundColor: "#fafafa",
              borderBottom: "1px solid #e5e5e7",
              padding: isMobile ? "0 8px" : "0 32px",
              overflowX: isMobile ? "auto" : "visible",
            }}
          >
            {tabs.map((tab) => {
              const isAvailable = getAvailableSteps().includes(tab.id);
              const isClickable = getClickableSteps().includes(tab.id);
              const isCompleted = completedSteps.has(tab.id);
              const isCurrent = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => isClickable && setActiveTab(tab.id)}
                  disabled={!isClickable}
                  style={{
                    flex: isMobile ? "0 0 auto" : 1,
                    padding: isMobile ? "20px 12px" : "24px 16px",
                    border: "none",
                    backgroundColor: "transparent",
                    color: !isAvailable
                      ? "#c7c7cc"
                      : isCurrent
                      ? "#1d1d1f"
                      : isCompleted
                      ? "#34c759"
                      : "#86868b",
                    fontSize: isMobile ? "15px" : "17px",
                    fontWeight: isCurrent ? "600" : "400",
                    cursor: isClickable ? "pointer" : "not-allowed",
                    borderBottom: isCurrent
                      ? "2px solid #1d1d1f"
                      : isCompleted
                      ? "2px solid #34c759"
                      : "2px solid transparent",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: isMobile ? "8px" : "10px",
                    minWidth: isMobile ? "80px" : "auto",
                    whiteSpace: "nowrap",
                    opacity: isAvailable ? 1 : 0.5,
                  }}
                  onMouseOver={(e) => {
                    if (isClickable && !isCurrent) {
                      e.target.style.color = isCompleted
                        ? "#2fb84d"
                        : "#1d1d1f";
                      e.target.style.backgroundColor = "rgba(0, 0, 0, 0.02)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (isClickable && !isCurrent) {
                      e.target.style.color = isCompleted
                        ? "#34c759"
                        : "#86868b";
                      e.target.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span
                    style={{
                      fontSize: isMobile ? "18px" : "20px",
                      fontWeight: "600",
                      color: !isAvailable
                        ? "#c7c7cc"
                        : isCurrent
                        ? "#1d1d1f"
                        : isCompleted
                        ? "#34c759"
                        : "#86868b",
                      backgroundColor: isCurrent
                        ? "#f0f0f0"
                        : isCompleted
                        ? "#e8f5e8"
                        : "transparent",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      minWidth: "24px",
                      textAlign: "center",
                      display: "inline-block",
                      position: "relative",
                    }}
                  >
                    {isCompleted ? "✓" : tab.icon}
                  </span>
                  {tab.label}
                  {isCompleted && (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#34c759",
                        marginLeft: "4px",
                        fontWeight: "600",
                      }}
                    >
                      ✓
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          {/* Form Content */}
          <form style={{ padding: isMobile ? "20px 16px" : "40px 32px" }}>
            {/* Table Header */}
            <div
              style={{
                display: isMobile ? "none" : "grid",
                gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
                gap: "20px",
                marginBottom: "32px",
                padding: "20px 0",
                borderBottom: "2px solid #f0f0f0",
                fontWeight: "600",
                fontSize: "14px",
                color: "#1d1d1f",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                textAlign: "center",
              }}
            >
              <div>{getColumnHeader(activeTab)}</div>
              <div>Basic Emotion</div>
              <div>Valence (1-5 Likert)</div>
              <div>Arousal (1-5 Likert)</div>
              <div>Reasoning (What signals)</div>
            </div>

            {/* Content Rows */}
            {(showSingleFile
              ? formData[activeTab].slice(0, 1)
              : formData[activeTab]
            ).map((item, index) => (
              <div
                key={index}
                style={{
                  display: isMobile ? "block" : "grid",
                  gridTemplateColumns: isMobile
                    ? "none"
                    : "2fr 1fr 1fr 1fr 2fr",
                  gap: isMobile ? "16px" : "20px",
                  marginBottom: "24px",
                  padding: isMobile ? "20px" : "28px",
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                  borderRadius: isMobile ? "12px" : "16px",
                  border: "1px solid #f0f0f0",
                }}
              >
                {/* Content Display */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isMobile && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#1d1d1f",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {getColumnHeader(activeTab)}
                    </div>
                  )}
                  <div
                    style={{
                      padding: isMobile ? "16px" : "20px",
                      backgroundColor: "white",
                      border: "2px solid #e5e5e7",
                      borderRadius: isMobile ? "12px" : "16px",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#1d1d1f",
                      minHeight: isMobile ? "80px" : "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "500",
                    }}
                  >
                    {activeTab === "text" && (
                      <div style={{ textAlign: "left", width: "100%" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#8e8e93",
                            marginBottom: "8px",
                          }}
                        >
                          {item.filename}
                        </div>
                        <div>{item.content || "Loading..."}</div>
                      </div>
                    )}
                    {activeTab === "audio" && (
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#8e8e93",
                            marginBottom: "12px",
                          }}
                        >
                          {item.filename}
                        </div>
                        <audio
                          controls
                          style={{
                            width: "100%",
                            maxWidth: isMobile ? "100%" : "300px",
                          }}
                          src={`/acmmi/audio/${item.filename}`}
                        >
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    )}
                    {activeTab === "visual" && (
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#8e8e93",
                            marginBottom: "12px",
                          }}
                        >
                          {item.filename}
                        </div>
                        <video
                          controls
                          style={{
                            width: "100%",
                            maxWidth: isMobile ? "100%" : "300px",
                            maxHeight: isMobile ? "250px" : "200px",
                          }}
                          src={`/acmmi/video-visual/${item.filename}`}
                        >
                          Your browser does not support the video element.
                        </video>
                      </div>
                    )}
                    {activeTab === "video" && (
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#8e8e93",
                            marginBottom: "12px",
                          }}
                        >
                          {item.filename}
                        </div>
                        <video
                          controls
                          style={{
                            width: "100%",
                            maxWidth: isMobile ? "100%" : "300px",
                            maxHeight: isMobile ? "250px" : "200px",
                            marginBottom: "16px",
                          }}
                          src={`/acmmi/video/${item.filename}`}
                        >
                          Your browser does not support the video element.
                        </video>
                        {/* Transcript Display */}
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "12px",
                            marginTop: "12px",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#6c757d",
                              fontWeight: "600",
                              marginBottom: "8px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Transcript
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              lineHeight: "1.5",
                              color: "#495057",
                              fontStyle: "italic",
                            }}
                          >
                            {item.content || "Loading transcript..."}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Basic Emotion Dropdown */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {isMobile && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#1d1d1f",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        alignSelf: "flex-start",
                      }}
                    >
                      Basic Emotion
                    </div>
                  )}
                  <select
                    value={item.emotion}
                    onChange={(e) =>
                      handleInputChange(
                        activeTab,
                        index,
                        "emotion",
                        e.target.value
                      )
                    }
                    style={{
                      width: "100%",
                      padding: isMobile ? "12px 14px" : "14px 16px",
                      border: "2px solid #e5e5e7",
                      borderRadius: isMobile ? "10px" : "12px",
                      fontSize: isMobile ? "14px" : "15px",
                      backgroundColor: "white",
                      color: "#1d1d1f",
                      cursor: "pointer",
                      fontWeight: "500",
                      textAlign: "center",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007AFF";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(0, 122, 255, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e5e7";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select emotion</option>
                    {basicEmotions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Valence Dropdown */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {isMobile && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#1d1d1f",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        alignSelf: "flex-start",
                      }}
                    >
                      Valence (1-5)
                    </div>
                  )}
                  <select
                    value={item.valence}
                    onChange={(e) =>
                      handleInputChange(
                        activeTab,
                        index,
                        "valence",
                        e.target.value
                      )
                    }
                    style={{
                      width: "100%",
                      padding: isMobile ? "12px 14px" : "14px 16px",
                      border: "2px solid #e5e5e7",
                      borderRadius: isMobile ? "10px" : "12px",
                      fontSize: isMobile ? "14px" : "15px",
                      backgroundColor: "white",
                      color: "#1d1d1f",
                      cursor: "pointer",
                      fontWeight: "500",
                      textAlign: "center",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007AFF";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(0, 122, 255, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e5e7";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select rating</option>
                    {likertOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Arousal Dropdown */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {isMobile && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#1d1d1f",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        alignSelf: "flex-start",
                      }}
                    >
                      Arousal (1-5)
                    </div>
                  )}
                  <select
                    value={item.arousal}
                    onChange={(e) =>
                      handleInputChange(
                        activeTab,
                        index,
                        "arousal",
                        e.target.value
                      )
                    }
                    style={{
                      width: "100%",
                      padding: isMobile ? "12px 14px" : "14px 16px",
                      border: "2px solid #e5e5e7",
                      borderRadius: isMobile ? "10px" : "12px",
                      fontSize: isMobile ? "14px" : "15px",
                      backgroundColor: "white",
                      color: "#1d1d1f",
                      cursor: "pointer",
                      fontWeight: "500",
                      textAlign: "center",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007AFF";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(0, 122, 255, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e5e7";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select rating</option>
                    {likertOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Reasoning Textarea */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {isMobile && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#1d1d1f",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        alignSelf: "flex-start",
                      }}
                    >
                      Reasoning
                    </div>
                  )}
                  <textarea
                    value={item.reasoning}
                    onChange={(e) =>
                      handleInputChange(
                        activeTab,
                        index,
                        "reasoning",
                        e.target.value
                      )
                    }
                    placeholder="What signals indicate this emotion?"
                    style={{
                      width: "100%",
                      padding: isMobile ? "12px 14px" : "14px 16px",
                      border: "2px solid #e5e5e7",
                      borderRadius: isMobile ? "10px" : "12px",
                      fontSize: isMobile ? "14px" : "15px",
                      backgroundColor: "white",
                      color: "#1d1d1f",
                      minHeight: isMobile ? "80px" : "100px",
                      resize: "vertical",
                      fontFamily: "inherit",
                      fontWeight: "500",
                      lineHeight: "1.5",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007AFF";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(0, 122, 255, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e5e7";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            ))}

            {/* Save and Proceed Button - Show for current step if not completed */}
            {!completedSteps.has(activeTab) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: isMobile ? "32px" : "48px",
                  paddingTop: isMobile ? "24px" : "32px",
                  borderTop: "2px solid #f0f0f0",
                }}
              >
                <button
                  type="button"
                  onClick={() => handleSaveAndProceed(activeTab)}
                  disabled={isSaving || !isStepCompleted(activeTab)}
                  style={{
                    backgroundColor:
                      isStepCompleted(activeTab) && !isSaving
                        ? "#007AFF"
                        : "#c7c7cc",
                    color: "white",
                    border: "none",
                    padding: isMobile ? "16px 40px" : "18px 56px",
                    borderRadius: isMobile ? "12px" : "16px",
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: "600",
                    cursor:
                      isStepCompleted(activeTab) && !isSaving
                        ? "pointer"
                        : "not-allowed",
                    transition: "all 0.2s ease",
                    boxShadow:
                      isStepCompleted(activeTab) && !isSaving
                        ? "0 4px 16px rgba(0, 122, 255, 0.15)"
                        : "none",
                    letterSpacing: "0.3px",
                    width: isMobile ? "100%" : "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    if (isStepCompleted(activeTab) && !isSaving) {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 8px 24px rgba(0, 122, 255, 0.25)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (isStepCompleted(activeTab) && !isSaving) {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 16px rgba(0, 122, 255, 0.15)";
                    }
                  }}
                >
                  {isSaving ? (
                    <>
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      Saving...
                    </>
                  ) : (
                    <>
                      Save and Proceed to{" "}
                      {tabs.find((t) => t.id === getNextStep(activeTab))
                        ?.label || "Next Step"}
                    </>
                  )}
                </button>
              </div>
            )}

            {/* Step completion message */}
            {completedSteps.size < 4 && !completedSteps.has(activeTab) && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: isMobile ? "32px" : "48px",
                  paddingTop: isMobile ? "24px" : "32px",
                  borderTop: "2px solid #f0f0f0",
                }}
              >
                <p
                  style={{
                    color: "#86868b",
                    fontSize: isMobile ? "14px" : "16px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Complete all fields in the current step and click "Save and
                  Proceed" to continue
                </p>
              </div>
            )}
          </form>
        </div>
        {/* Footer note */}
        <div
          style={{
            textAlign: "center",
            marginTop: isMobile ? "16px" : "24px",
            color: "#86868b",
            fontSize: isMobile ? "12px" : "14px",
          }}
        >
          Homework created by Jingyao Wu and Chenyu Zhang.
        </div>
      </div>
    </>
  );
};

export default Acmmi;
